import { FC } from 'react';
import { IAccountTable } from 'models/Account';
import Tooltip from '../../../widgets/tooltip';
import NetworksBadge from './NetworksBadge';

interface AccountIdCellProps {
    account: IAccountTable;
}

/**
 * The account's primary ID, plus a badge listing the rest of its networks when it has more than one.
 * Accounts with a single network render exactly as they did before this column gained the badge.
 */
const AccountIdCell: FC<AccountIdCellProps> = ({ account }) => {
    const networks = account.associatedNetworks ?? [];

    return (
        <div className="account-id-cell">
            <Tooltip title={account.networkId?.toString()} disable={false}>
                <span className="ellipsis">{account.networkId}</span>
            </Tooltip>
            {networks.length > 1 && <NetworksBadge networks={networks} />}
        </div>
    );
};

export default AccountIdCell;
